// src/components/WhatWeDo/WhatWeDo.js
import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './WhatWeDo.css';

// Import Images
import img1 from '../../assets/WhatWeDo/img (1).png';
import img2 from '../../assets/WhatWeDo/img (2).png';
import img3 from '../../assets/WhatWeDo/img (3).png';

const WhatWeDo = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const slides = [
    {
      id: 1,
      title: "Cold Forging & Heat Treatment",
      description: "High-strength cold-forged components with in-house heat treatment processes including hardening, tempering, and controlled thermal cycles to ensure durability and dimensional accuracy.",
      imgUrl: img1,
    },
    {
      id: 2,
      title: "Engine & Auto Component Assembly",
      description: "High-speed stamping presses ranging from 40T to 400T capacity. We specialize in complex progressive die stamping for intricate automotive components, ensuring high volume production with consistent accuracy and minimal waste.",
      imgUrl: img2
    },
    {
      id: 3,
      title: "Automotive Precision Components",
      description: "Automotive Precision Components Manufacturing of high-precision automotive components including fuel injection parts, transmission components, steering parts, and brake systems for leading OEMs.",
      imgUrl: img3
    }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const nextSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    setTimeout(() => setIsAnimating(false), 500);
  };

  const prevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    setTimeout(() => setIsAnimating(false), 500);
  };

  const activeSlide = slides[currentSlide];

  return (
    <section className="what-we-do-section" id="capabilities">
      <Container>
        <Row className="align-items-center">
          
          {/* LEFT COLUMN: TEXT & NAV */}
          <Col lg={5} md={12}>
            <div 
              key={activeSlide.id} 
              className="content-wrapper fade-enter-active"
            >
              <span className="section-label" data-aos="fade-down">What We Do</span>
              
              <h2 className="slide-title">
                {activeSlide.title}
              </h2>
              
              <p className="slide-desc">
                {activeSlide.description}
              </p>
            </div>

            {/* Navigation Buttons */}
            {/* REMOVED INLINE STYLE - Now handled in CSS class .nav-btn-container */}
            <div className="nav-btn-container" data-aos="fade-up">
              <button className="nav-arrow-btn" onClick={prevSlide} aria-label="Previous">
                <BsArrowLeft />
              </button>
              <button className="nav-arrow-btn" onClick={nextSlide} aria-label="Next">
                <BsArrowRight />
              </button>
            </div>
          </Col>

          {/* RIGHT COLUMN: IMAGE */}
          <Col lg={7} md={12}>
            <div className="slide-img-wrapper" data-aos="fade-left">
              <img 
                key={activeSlide.id}
                src={activeSlide.imgUrl} 
                alt={activeSlide.title} 
                className="slide-img fade-enter-active"
              />
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default WhatWeDo;